import * as angular from 'angular';
import { NvInputNumberLimiter } from '../../../../../../../shared/directives/input-number-limiter/input-number-limiter.directive';
import { MetricsTextInputRowComponent } from './metrics-text-input-row.component';

export const MetricsTextInputRowModule = angular
  .module('metricsTextInputRow', [])
  .component('metricsTextInputRow', MetricsTextInputRowComponent)
  .directive('nvInputNumberLimiter', () => new NvInputNumberLimiter()).name;
